import { render, staticRenderFns } from "./syslogs.vue?vue&type=template&id=5422e276&scoped=true&"
import script from "./syslogs.vue?vue&type=script&lang=js&"
export * from "./syslogs.vue?vue&type=script&lang=js&"
import style0 from "./syslogs.vue?vue&type=style&index=0&id=5422e276&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5422e276",
  null
  
)

export default component.exports